export default {
  closeStore: '关闭店铺',
  sellerApply: '商家申请',
  storeCloseConditionsReview: '闭店条件审核',
  questionnaireCompletion: '问卷填写',
  infoVerification: '信息验证',
  platformReview: '平台审核',
  storeClosed: '店铺关闭',
  securityDepositRefund: '保证金退款',
  cancelApply: '取消申请',
  next: '继续关闭店铺',
  sellerApplyTitle: '1、请仔细阅读一下内容',
  sellerApplyContent1: '您正在提交永久关闭Kilimall店铺并删除数据的申请。店铺成功关闭后，所有店铺信息将被注销，重新开店也无法恢复历史数据。',
  sellerApplyContent2: '若您继续关闭店铺，将无法访问以下与当前店铺相关的产品和服务：',
  sellerApplyContent3: '1）店铺的结算账单、资金账户等。',
  sellerApplyContent4: '2）销售订单、退款退货订单、订阅关系等客户资料。',
  sellerApplyContent5: '3）商品图片、商品描述以及买家的商品评价等商品资料。',
  sellerApplyContent6: '流程相关通知会通过主账号邮件与电话号码发送，请确保当前账号邮件与电话号码能够正常使用。',
  sellerApplyContent7: '请注意，一旦申请退店，店铺存在被关闭的风险，且关闭后无法重启回复原本数据。请您确认无误后再提交退店申请。',
  selfVerifyMeet: '2、请自检是否达到闭店条件',
  closureRequirements: '闭店条件',
  exceptionStatus: '异常情况',
  recommendedAction: '推荐操作',
  storeOperatingGreaterMonths: '开店时长超过6个月',
  lastCompletedAgo: '最后一个订单完成超过3个月',
  noStockWarehouse: 'FBK仓库无存货',
  none: '无',
  previousBtn: '返回上一步 >>>',
  storeOperatingLessMonths: '开店时长不足6个月',
  lastOrderLessMonths: '最后一个订单完成时间不足3个月',
  fbkWarehouseStock: '部分商品存在FBK库存',
  recommendTemporarilyClose: '建议将店铺歇业并等待{0}天',
  returnWarehouseInventory: '将货物退仓或报废',
  noteStockShown: '注：此处显示商城前端库存，小概率会与真实库存出现偏差，如有异常，请主动联系客服进行排查。',
  clickToDetail: '点击前往查看',
  detailedRulesStoreClosure: '《店铺关闭详情规则》',
  temporarilyClosingStore: '歇业店铺',
  productsInactive: '店铺内商品全部下架',
  storeActiveProducts: '店铺存在上架商品',
  setAllActive: '下架全部商品',
  threeReasonStoreClose: '3、请选择关闭店铺的原因',
  currentlyOperateStore: '暂时没有时间经营',
  fewOrdersRevenue: '店铺订单少，收益低',
  anotherStore: '我有另外的店铺',
  openNewStore: '我想新建店铺',
  longerOperateStore: '我不想再经营这个店铺',
  platformCustomerPoor: `平台客户服务差`,
  platformWebsiteSlow: '平台客户访问网页慢',
  platformPaymentLong: `平台回款时间长`,
  platformCountryLocations: '平台国家站点少',
  otherReasonSpecify: '其他原因（请写明）',
  enterReason: '请输入原因',
  checkAccountNumber: '4、请核对保证金缴纳账号，保证金将退款至该账户，如有特殊情况可进行修改',
  bankAccountNo: '银行卡卡号',
  bankAccountName: '银行卡账户名称',
  bankBranchName: '银行卡开户详细支行',
  modify: '修改',
  changeDepositAccount: '修改保证金退款账户',
  noteBankAccount: '注：请确保保证金缴纳账户与保证金退款账户开户人一致，请不要填写信用卡，否则会造成退款失败。',
  cancel: '取消',
  confirm: '确认',
  depositRefundAccount: '您的保证金退款账户为',
  identityVerificationCode: '5、使用验证码核实身份',
  phoneNumber: '电话号码',
  verificationCode: '验证码',
  send: '获取验证码',
  confirmStoreClosure: '确认关闭店铺',
  storeClosureApplySuccess: '关闭店铺申请成功！',
  officialProcessContactPassed: '您已经申请关闭店铺{0}国家站{1}，平台将在2-3月内处理您的闭店申请，审核通过后将会通过电话/邮箱联系您。',
  failedOfficialReview: '平台审核未通过',
  reasonFailure: '未通过的原因',
  reapply: '重新申请',
  ruleInput: '请输入',
  storeClosureApproved: '关闭店铺审核通过！',
  approvedTips: '您关闭店铺{0}国家站{1}的申请平台已经审核通过，平台财务将主动联系您进行退款，请保持电话/邮件正常使用。',
  operateSuccessful: '操作成功'
}
